export default import.meta.ROLLDOWN_FILE_URL_icibL6KnJSP7tMpehf2TGg